const EditMemberValidation = (props) => {
    if (props.editFields?.edithhm == "") {
        props.handleShow()
        props.handleValidationMsg("Please select what you would like to edit about the household member.", "Oops!")
        return false
    }
    else if (props.editFields?.edithhm == "1" && props.editFields.edithhmNested == "") {
        props.handleShow()
        props.handleValidationMsg("Please select how this person's insurance will be handled now having a driver's license.", "Oops!")
        return false
    }
    else if (props.editFields?.edithhm == "1" && props.editFields.edithhmNested == "0" && props.editFields.licenseNumber == "") {
        props.handleShow()
        props.handleValidationMsg("Please provide the license number.", "Oops!")
        return false
    }
    else {
        return true
    }
}

export default EditMemberValidation